import { useSelector } from 'react-redux';
import Conditional from '@next-app/components/Conditional';
import { FC } from 'react';
import Image from 'next/image';
import {
  getFormattedPrice,
  isNotNullOrUndefinedorEmpty,
} from '@next-app/utils/common-utils';
import { selectContractedItemsLabel } from '@next-app/lib/features/InitSelectors';

interface MiniCartProps {
  productImage: string | null;
  quantity: number;
  priceInfo: any;
  skuDisplayName: string;
  isFurnitureItem: boolean;
  showLabel: boolean;
}

const MiniCartLineItems: FC<MiniCartProps> = ({
  productImage,
  quantity,
  priceInfo,
  skuDisplayName,
  isFurnitureItem,
  showLabel,
}) => {
  const contractedItemsLabel = useSelector(selectContractedItemsLabel);
  return (
    <div className="d-flex justify-content-between pt-ll-10 pb-ll-10 gap-ll-3">
      <div className="d-flex gap-ll-3">
        <div
          className="position-relative d-flex align-items-center justify-content-center bg-white"
          style={{
            maxWidth: '64px',
            minWidth: '64px',
            top: '2px',
            height: '48px',
          }}
        >
          <Conditional if={isNotNullOrUndefinedorEmpty(productImage)}>
            <Image
              unoptimized={true}
              src={productImage || ''}
              alt={skuDisplayName}
              width={64}
              height={48}
              className="position-relative object-fit-inherit"
              style={{
                maxHeight: '48px',
                maxWidth: '100%',
                objectFit: 'contain',
                margin: 'auto',
                display: 'block',
              }}
            />
          </Conditional>
          <span
            className="d-flex align-items-center justify-content-center position-absolute top-0 start-100 translate-middle badge rounded-circle bg-danger fs-ll-11 px-1"
            style={{ width: '24px', height: '24px', lineHeight: '24px' }}
          >
            {quantity}
          </span>
        </div>
        <div className="fw-light fs-sm lh-sm" style={{ maxWidth: '220px' }}>
          <Conditional if={showLabel}>
            <span
              className="d-block fs-xs lh-sm fw-lighter"
              style={{ color: '#717171' }}
            >
              {isFurnitureItem ? 'Lakeshore Furniture' : 'Lakeshore'}
            </span>
          </Conditional>
          <span
            className="fs-ll-md-13 fw-lighter-md-light"
            dangerouslySetInnerHTML={{ __html: skuDisplayName }}
          ></span>
        </div>
      </div>
      <div>
        <Conditional
          if={
            priceInfo.discounted || (priceInfo.onSale && !priceInfo.discounted)
          }
        >
          <>
            <span className="d-block text-danger fs-ll-md-13">
              {getFormattedPrice(priceInfo.amount)}
            </span>
            <span
              className="d-block fs-xs text-end text-decoration-line-through fs-ll-md-13"
              style={{ color: '#717171' }}
            >
              {getFormattedPrice(priceInfo.rawTotalPrice)}
            </span>
          </>
        </Conditional>
        <Conditional
          if={
            !priceInfo.discounted && !priceInfo.onSale && priceInfo.hasGSAPrice
          }
        >
          <>
            <span
              className="d-block fs-ll-md-13 text-end"
              style={{ color: '#18B335' }}
            >
              {getFormattedPrice(priceInfo.amount)}{' '}
              <Conditional if={contractedItemsLabel.length > 0}>
                <span className="text-uppercase d-block">
                  {contractedItemsLabel}
                </span>
              </Conditional>
            </span>
          </>
        </Conditional>
        <Conditional
          if={
            !priceInfo.discounted && !priceInfo.onSale && !priceInfo.hasGSAPrice
          }
        >
          <span className="d-block fs-ll-md-13 lh-sm">
            {getFormattedPrice(priceInfo.amount)}
          </span>
        </Conditional>
      </div>
    </div>
  );
};

export default MiniCartLineItems;
